import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from 'consts';
import { VerificationLayout } from 'layouts';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

export const VerificationNavigator = () => {
  const { orgSlug, isLoggedIn, emailVerified } = useAppSelector(selectCurrentUserInfo);
  const location = useLocation();
  const navigate = useNavigate();

  const { from } = location.state
    ? (location.state as { from: string })
    : { from: `/${ROUTES.ORG_SLUG.replace(':orgSlug', orgSlug)}` };

  React.useEffect(() => {
    if (!isLoggedIn) {
      navigate(`/${ROUTES.AUTH}/${ROUTES.AUTH_LOGIN}`, { replace: true });
    } else if (emailVerified) {
      navigate(from);
    } else if (location.pathname === ROUTES.VERIFICATION) {
      navigate(ROUTES.VERIFICATION_REQUEST);
    }
  }, [location.pathname, isLoggedIn, emailVerified]);

  return (
    <VerificationLayout>
      <Outlet />
    </VerificationLayout>
  );
};
